import React, { useEffect, useState } from 'react';
import Dialog from '../../ui/Dialog';
import LoadingOverlay from '../../LoadingOverlay/LoadingOverlay.component';
import DatePicker from '../../DatePicker/DatePicker.component';
import { updateAppointment } from '../../../services/appointment.service';
import { Button, makeStyles, TextField, Typography, Grid, 
    Select, MenuItem, InputLabel, Switch } from '@material-ui/core';
import './appointment.scss';
import moment from 'moment';

const UpdateAppointmentDetails = ({ data }) => {
  const { appointment_id, program_id, appointment_date, start_time, end_time, duration_minutes, channel, notes, status } = data;
  const [openModal, setOpenModal] = useState(false);
  const [openConfirmation, setConfirmation] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [isLoading, setLoading] = useState(false);
  
  const [errorInputMessage, setErrorInputMessage] = useState(null);
  const useStyles = makeStyles(() => ({
    field: {
      marginBottom: 10,
      width: '100%'
    },
    select: {
      width: '100%'
    },
    formControl: {
      width: '100%'
    }
  }));
  const classes = useStyles();
  interface AppointmentDetails {
  appointment_date: any;
  appointment_start_time: any;
  appointment_end_time: any;
  notes: string;
  channel: string;
  duration_in_minutes: number;
  status:any
  }
    const [appointmentDetails, setAppointmentDetails] = useState<AppointmentDetails>({
    appointment_date: moment(appointment_date).format("YYYY-MM-DD"),
    appointment_start_time: start_time,
    appointment_end_time: end_time,
    notes,
    channel,
    duration_in_minutes: duration_minutes,
    status
  });
  const currentDate = new Date();
  const listOfChannel = [
    {
      value: "face-to-face",
      label: "Face to Face" 
    },
    {
      "value": "call",
      "label": "Call"
    },
    {
      value: "video",
      label: "Video"
    },
    {
      value: "email",
      label: "Email"
    },
    {
      value: "chat",
      label: "Chat"
    }
  ]

  const appointmentStatusList = [
    {
      value: "scheduled",
      label: "Scheduled" 
    },
    {
      "value": "rescheduled",
      "label": "Rescheduled"
    },
    {
      value: "cancelled",
      label: "Cancelled"
    },
    {
      value: "no-show",
      label: "No Show"
    },
    {
      value: "completed",
      label: "Completed"
    }
  ]

  const onClick = async () => {
    setAppointmentDetails({
      appointment_date: moment(appointment_date).format("YYYY-MM-DD"),
    appointment_start_time: start_time,
    appointment_end_time: end_time,
    notes,
    channel,
    duration_in_minutes: duration_minutes,
    status
    })
    setOpenModal(true);
  };

 const validateForm = () => {
          const errors: Partial<Record<keyof AppointmentDetails, string>> = {};

        let isValid = true;
      
        if (!appointmentDetails.channel) {
            errors.channel = 'Channel is required';
            isValid = false;
        }

        if (!appointmentDetails.duration_in_minutes) {
            errors.duration_in_minutes = "Duration is required";
            isValid = false;
        }
        if (!appointmentDetails.notes) {
            errors.notes = "Notes is required";
            isValid = false;
        }

        setErrorInputMessage(errors);
        return isValid;
    };



  const onSubmit = async() => {
     if (!validateForm()) {
            return;
        }
    try {
      setLoading(true);
      const userOffsetMinutes = new Date().getTimezoneOffset();    
      const formatDateTime = (date: string, time: string) => {
        return moment(`${date} ${time}`, 'YYYY-MM-DD HH:mm')
          .utcOffset(-userOffsetMinutes)
          .toISOString();
      };
  
      const { result, message } = await updateAppointment(program_id, 
        {
          appointment_id,
          start_datetime: formatDateTime(
            moment(appointmentDetails.appointment_date).format('YYYY-MM-DD'),
            appointmentDetails.appointment_start_time
          ),
          end_datetime: formatDateTime(
            moment(appointmentDetails.appointment_date).format('YYYY-MM-DD'),
            appointmentDetails.appointment_end_time
          ),
          notes: appointmentDetails.notes,
          channel: appointmentDetails.channel,
          duration_minutes: appointmentDetails.duration_in_minutes,
          status: appointmentDetails.status
        }
      );

      if (result || message) {
        setOpenModal(false);
        setConfirmation(true);
      }
    } catch(err) {
      if (err && err.inputs && err.message === 'ValidationError') {
        setErrorInputMessage(err.inputs);
      } else if (err && err.message) {
        alert(err.message);
      }
    } finally {
      setLoading(false);
    }
  }

  const onFieldInput = (e) => {
    if (e && e.target) {
      const { name, value } = e.target;

      setAppointmentDetails(prevState => ({
        ...prevState,
        [name]: value,
      }));
    }
  }

  const onDateChange = (e) => {
    setAppointmentDetails(prevState => ({
      ...prevState,
      ['appointment_date']: e,
    }));
  }

  const onTimePickerChange = (e) => {
    const timeSelected = e.currentTarget.value;
    const name = e.target.name;

    setAppointmentDetails(prevState => ({
      ...prevState,
      [name]: timeSelected,
    }));
  }

  const formContent = (
    <div style={{ width: "400px" }}>
      <Grid
        item
        container
        xs={12}
        spacing={2}
      >
        <Grid item xs={6}>
          <InputLabel>Appointment Date</InputLabel>
            <DatePicker
              required={true}
              onChange={onDateChange}
              name='appointment_date'
              className={classes.field} 
              defaultValue={currentDate}
              value={appointmentDetails.appointment_date}
            />
            <Typography
              variant='caption'
              display='block'
              gutterBottom
              color='error'
            >
            { errorInputMessage ? errorInputMessage.appointment_date : '' }
            </Typography>
        </Grid>
        <Grid item xs={6}>
          <InputLabel>Status</InputLabel>
          <Select 
            required={true}
            label='Status'
            name="status"
            variant='outlined' 
            defaultValue={appointmentDetails.status}
            className={classes.field}
            onChange={onFieldInput}
          >
            {
              appointmentStatusList && appointmentStatusList.length ? appointmentStatusList.map(appointmentStatus => {
                return (
                  <MenuItem key={appointmentStatus.value} value={appointmentStatus.value}>
                    {appointmentStatus.label}
                  </MenuItem>
                )
              }) : <></>
            }
          </Select>
          <Typography
            variant='caption'
            display='block'
            gutterBottom
            color='error'
          >
            { errorInputMessage ? errorInputMessage.status : '' }
          </Typography>
        </Grid>
      </Grid>
      <Grid
        item
        container
        xs={12}
        spacing={2}
      >
        <Grid item xs={6}>
          <InputLabel>Start Time</InputLabel>
          <input 
            min="00:00"
            max="23:59"
            type="time"
            name="appointment_start_time"
            value={appointmentDetails.appointment_start_time}
            onChange={onTimePickerChange}
          />
          <Typography
            variant='caption'
            display='block'
            gutterBottom
            color='error'
          >
            { errorInputMessage ? errorInputMessage.appointment_start_time : '' }
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <InputLabel>End Time</InputLabel>
          <input
            min="00:00"
            max="23:59"
            type="time"
            name="appointment_end_time"
            value={appointmentDetails.appointment_end_time}
            onChange={onTimePickerChange}
          />
          <Typography
            variant='caption'
            display='block'
            gutterBottom
            color='error'
          >
            { errorInputMessage ? errorInputMessage.appointment_start_time : '' }
          </Typography>
        </Grid>
      </Grid>
      <Grid
        item
        container
        xs={12}
        spacing={2}>
        <Grid item xs={6}>
          <InputLabel>Channel</InputLabel>
          <Select 
            required={true}
            label='Channel'
            name="channel"
            variant='outlined' 
            defaultValue={appointmentDetails.channel}
            className={classes.field}
            onChange={onFieldInput}
          >
            {
              listOfChannel && listOfChannel.length ? listOfChannel.map(channel => {
                return (
                  <MenuItem key={channel.value} value={channel.value}>
                    {channel.label}
                  </MenuItem>
                )
              }) : <></>
            }
          </Select>
          <Typography
            variant='caption'
            display='block'
            gutterBottom
            color='error'
          >
            { errorInputMessage ? errorInputMessage.channel : '' }
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <InputLabel>Duration (mins)</InputLabel>
          <TextField className={classes.field} 
            required={true} 
            name='duration_in_minutes'
            type='number' 
            defaultValue={appointmentDetails.duration_in_minutes}  
            onChange={onFieldInput}
          />
          <Typography
            variant='caption'
            display='block'
            gutterBottom
            color='error'
          >
            { errorInputMessage ? errorInputMessage.duration_in_minutes : '' }
          </Typography>
        </Grid>
      </Grid>
      <Grid
          item
          container
          xs={12}
          spacing={2}
        >
          <Grid item xs={12}>
              <TextField 
                rows={12}
                multiline={true}
                required={true}
                label='Notes'
                name='notes' 
                defaultValue={appointmentDetails.notes}
                variant='outlined'
                className={classes.field}
                onChange={onFieldInput}
                />
              <Typography
                variant='caption'
                display='block'
                gutterBottom
                color='error'
              >
              { errorInputMessage ? errorInputMessage.notes : '' }
              </Typography>
          </Grid>
        </Grid>
    </div>
  );

  const handleClose = (reload) => {
    setOpenModal(false);
    setConfirmation(false);
    setErrorMessage(null);
    setErrorInputMessage(null);

    if (reload) {
      window.location.reload();
    }
  }

  const formButtons = (
    <>
      <Button onClick={() => handleClose(false)} variant='contained'>
        Close
      </Button>
      <Button onClick={onSubmit} variant='contained' color='secondary'>
        Submit
      </Button>
    </>
  );

  if (isLoading) {
    return <LoadingOverlay />;
  }

  return (
    <>
     <Dialog 
      key='update-appointment'
      open={openModal}
      title = 'Update Appointment'
      content = {formContent} 
      children = {formButtons} 
      onSubmit = {onSubmit}
      onClose = {() => handleClose(false)} 
      />
     <Dialog 
      key='confirmation'
      open={openConfirmation}
      title = 'Confirmation'
      content = 'Appointment successfully updated!' 
      children = {(
        <Button onClick={() => handleClose(true)} variant='contained'>
          Close
        </Button>
      )} 
      onSubmit = {onSubmit}
      onClose = {() => handleClose(true)} 
      />

    <Button variant="contained" onClick={onClick} style={{ marginRight: 8 }}>Edit & Update</Button>
    </>
  )
}

export default UpdateAppointmentDetails;
